export * from "modules/CommunicationSettings/components/DeskCheckIn";
export * from "modules/CommunicationSettings/components/DiagnoseOverview";
export * from "modules/CommunicationSettings/components/General";
export * from "modules/CommunicationSettings/components/Kiosk";
export * from "modules/CommunicationSettings/components/OnlineCheckIn";
export * from "modules/CommunicationSettings/components/RepairOverview";
export * from "modules/CommunicationSettings/components/ServiceTracker";
export * from "modules/CommunicationSettings/components/Support";
export * from "modules/CommunicationSettings/components/Variables";
